(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('dialogAction', dialogAction);

    function dialogAction(lodash, GenericModel, ButtonRegistry, FormBuilderService,Path, FormEventActions, $timeout, $injector, ActionCommon) {


        return function(actions, viewModel, btnEvent, eventData, close) {
            var route;
            mapFunction();
            angular.forEach(actions, function(action, actionName) {
                route[actionName](action);
            });

            function getModel() {
                if (lodash.has(viewModel.options, 'form.name')) {
                    var form_name = viewModel.options.form.name;
                    var fbService = FormBuilderService.get(form_name);
                    return fbService.model;
                } else {
                    return lodash.get(viewModel.options, action.data, {});
                }
            }

            function sendRequest(action) {
                var data = {
                    data: getModel(),
                    event: btnEvent.name
                };
                var model = new GenericModel(action.datasource.url);
                var method = lodash.get(action.datasource, 'method', 'get');


                model[method]({}, data, function(res) { //res
                    if (lodash.has(res, 'actions')) {
                        angular.forEach(res.actions, function(act, actionName) {
                            route[actionName](act);
                        });
                    } else {
                        runActionOnSuccess(action);
                    }
                    clearButtonLoading();

                }, function(res) {

                    viewModel.validation = {};
                    switch (res.status) {
                        case 422:
                            validation(res.data);
                            break;
                        case 404:case 500: break;
                    }
                    clearButtonLoading();
                });
            }

            function validation(data) {
                var form_name = viewModel.options.form.name;
                var fbService = FormBuilderService.get(form_name);
                fbService.elementsService.setValidationRules(data.rules, data.summary);

            }

            function clearModel() {
                viewModel.validation = {};
            }

            function callFormActions(actionData) {
                FormEventActions(actionData.form_name, actionData.actions, null, null);
            }

            function closeDialog(data) {
                $timeout(function() {
                    close(data);
                });
            }

            function redirect(data){
                var sub_id = '';
                var _path = Path.replace(data.destination, sub_id);
                Path.redirect(_path);
                closeDialog(data);
            }

            function runActionOnSuccess(action) {
                if (lodash.has(action, 'actionOnSuccess')) {
                    angular.forEach(action.actionOnSuccess, function(act, actionName) {
                        route[actionName](act);
                    });
                }
            }

            function clearButtonLoading() {
                ButtonRegistry.clearLoading(eventData.targetScope.name);
            }

            function refreshGrid(data) {
                var ListFilterStateFactory = $injector.get('ListFilterStateFactory');
                var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                listfilterService.refreshGrid();
            }

            function clearGridSelected(data) {
                var ListFilterStateFactory = $injector.get('ListFilterStateFactory');
                var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                listfilterService.clearSelected();
            }

            function mapFunction() {
                route = {
                    sendRequest: sendRequest,
                    clearModel: clearModel,
                    closeDialog: closeDialog,
                    redirect: redirect,
                    callFormActions: callFormActions,
                    refreshGrid: refreshGrid,
                    show_floating_notification: ActionCommon.show_floating_notifier,
                    show_static_notification: ActionCommon.show_static_notifier,
                    clearGridSelected: clearGridSelected
                };
            }
        };
    }
})();